import { useEffect, useContext } from 'react';
import { UniversalContext } from '../../../_universal';

function TrackViewedProviderEvent({ provider, id }) {
  const { trackEvent } = useContext(UniversalContext);

  useEffect(() => {
    if (provider) {
      trackEvent({
        event: 'Viewed Provider',
        properties: {
          providerDisplay: provider.display,
          providerId: provider.id,
          isOnlineSchedulingEnabled: provider.onlineSchedulingEnabled,
          widget: false,
        },
      });
    } else {
      trackEvent({
        event: 'Provider Not Found',
        properties: { providerId: id },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return null;
}

export default TrackViewedProviderEvent;
